"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOBILE_MAX_LANDSCAPE_WIDTH = exports.MOBILE_MAX_PORTRAIT_WIDTH = void 0;
exports.MOBILE_MAX_PORTRAIT_WIDTH = 375; // iPhone X max width in portrait
exports.MOBILE_MAX_LANDSCAPE_WIDTH = 812; // iPhone X max width in landscape
